import type { KeyboardEvent } from "react";

/** Arrow keys step between the enabled rows, as in a menu, on top of Tab. */
export function moveFocusWithArrows(event: KeyboardEvent<HTMLElement>) {
  if (event.key !== "ArrowDown" && event.key !== "ArrowUp") return;
  const rows = [
    ...event.currentTarget.querySelectorAll<HTMLButtonElement>(
      "button:not(:disabled)",
    ),
  ];
  const index = rows.findIndex((row) => row === document.activeElement);
  if (index === -1) return;
  event.preventDefault();
  rows[
    (index + (event.key === "ArrowDown" ? 1 : -1) + rows.length) % rows.length
  ]?.focus();
}
